import React from 'react';
import { Icon } from '@zillow/constellation-10';
import { IconCheckmarkOutline } from '@zillow/constellation-icons';
import * as S from './styles';

const ChecklistItem = (props = {}) => (
  <S.ChecklistItem>
    <S.Icon>
      <Icon size="sm" css={{ color: 'icon.accent.brand.hero' }} render={<IconCheckmarkOutline />} />
    </S.Icon>
    <S.Label>{props.children}</S.Label>
  </S.ChecklistItem>
);

export default ChecklistItem;
